import { memo, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "stores";
import store from "stores/interfaces";

import Room from "./Room";
import Loader from "./Loader";
import { subscribeUserState } from "stores/modules/app.user/operations";
import { loadFeatureConfig } from "stores/modules/app.state/operations";

type RoomContainerProps = {
  roomId: string;
};

const RoomContainer = ({ roomId }: RoomContainerProps) => {
  const dispatch = useAppDispatch();
  const uid = useAppSelector((state) => {
    return store.getAppState(state, "uid");
  });
  const settingsUid = useAppSelector((state) => state.entities.userSetting.uid);
  const loadedConfig = useAppSelector((state) =>
    store.getAppState(state, "loadedConfig")
  );

  useEffect(() => {
    return dispatch(subscribeUserState());
  }, [dispatch]);

  useEffect(() => {
    dispatch(loadFeatureConfig());
  }, [dispatch]);

  useEffect(() => {
    if (settingsUid) {
      dispatch(store.updateUserAccessStatus());
    }
  }, [dispatch, settingsUid]);

  if (!uid || !loadedConfig) {
    return <Loader loading={true} />;
  }
  return <Room roomId={roomId} uid={uid} />;
};

export default memo(RoomContainer);
